import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-markets',
  templateUrl: './markets.component.html',
  styleUrls: ['./markets.component.scss']
})
export class MarketsComponent implements OnInit {
  sportId: string | null = null;
  
  lotteryGames = [
    { name: 'TIME BAZAR' },
    { name: 'MILAN DAY' },
    { name: 'RAJDHANI DAY' },
    { name: 'KALYAN' },
    { name: 'MILAN NIGHT' },
    { name: 'KALYAN NIGHT' },
    { name: 'RAJDHANI NIGHT' },
    { name: 'MAIN BAZAR' }
  ];

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.sportId = params.get('sportId');
    });
  }
}
